<template>
  <div>
      <!-- <h2>退出界面</h2> -->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>